import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import { type MouseEvent } from 'react'

interface Props {
  disabled: boolean
  firstColumn: number
  lastColumn: number
  isRecurring?: boolean
  isInactive?: boolean
  onClick?: (event: MouseEvent<HTMLElement>) => void
  enhancedRecurringShiftsEnabled: boolean
  isPlaceholder?: boolean
}

const StyledCell = styled.div<Props>(props => ({
  background: getBackgroundColor(props),
  borderRadius: '6px',
  gridColumn: `${props.firstColumn}/${props.lastColumn}`,
  gridRow: '1/1',
  marginTop: '17px',
  marginBottom: '17px',
  textAlign: 'center',
  padding: '2px',
  position: 'relative',
  '&:after': props.isInactive && {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
    opacity: 0.45,
  },
  '&:hover': props.isRecurring &&
    props.enhancedRecurringShiftsEnabled &&
    !props.disabled &&
    !props.isInactive && {
      background: '#000000',
    },
}))

export default StyledCell

const getBackgroundColor = props => {
  if (props.disabled || props.isInactive) {
    return '#72767E' // rgb(114, 118, 126)
  }
  if (props.enhancedRecurringShiftsEnabled && props.isRecurring) {
    return '#343538' // rgb(52, 53, 56)
  }
  if (props.isPlaceholder) {
    return '#2B78C6' // rgb(43, 120, 198)
  }
  //System/Grayscale/70 non recurring single shift
  return props.enhancedRecurringShiftsEnabled ? '#343538' : colors.GREEN_500
}
